import axios from 'axios';
import { supabase } from './supabase';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Attach Supabase token to every request
api.interceptors.request.use(async (config) => {
  // Skip if Authorization is already set (e.g., from explicit calls)
  if (config.headers.Authorization) return config;

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    }
  } catch {
    // No session, continue without auth
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Check if we still have a valid Supabase session
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        if (window.location.pathname.startsWith('/admin') ||
            window.location.pathname.startsWith('/espace')) {
          window.location.href = '/connexion';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { API_BASE, BACKEND_URL };
